export const chartGridStyles = {
  chartTile: { height: '180px', padding: '2px' },
};
